/* eslint-disable react/prop-types */
import React from 'react';
import { Box, Grid } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import TextFieldInfo from './TextFieldInfo';
import ColorButtonPurple from './ColorButtonPurple.js';
import Checkbox from '@material-ui/core/Checkbox';
import firebase, { db } from '../Firebase.js';
import { withRouter } from 'react-router';

const closeIconProps = {
  color: '#FFFF',
  bgcolor: '#9B88FF',
  borderRadius: 15,
};

class PrintModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { name: null, company: null, busho: null, email: null, doui: false, error: false };
  }

  handleNameChange(value) {
    this.setState({ name: value });
    this.handleInputCheck();
  }

  handleCompanyChange(value) {
    this.setState({ company: value });
    this.handleInputCheck();
  }

  handleBushoChange(value) {
    this.setState({ busho: value });
    this.handleInputCheck();
  }

  handleEmailChange(value) {
    this.setState({ email: value });
    this.handleInputCheck();
  }

  handleDouiChange(e) {
    this.setState({ doui: e.target.checked });
    this.handleInputCheck();
  }

  handleInputCheck() {
    if (this.state.name == null || this.state.company == null || this.state.busho == null || this.state.email == null) {
      this.setState({ error: true });
    } else {
      this.setState({ error: false });
    }
  }

  //PDFボタンが押されたら
  handelOnPDF() {
    this.handleInputCheck();
    if (this.state.error || !this.state.doui) {
      return;
    } else {
      this.props.savePdf();
      this.addToDatabese();
      this.props.history.push('/thankyou');
    }
  }

  //データベースに追加
  addToDatabese() {
    const docId = db.collection('work-palce-simulator-trial').doc().id;
    db.collection('work-palce-simulator-trial')
      .doc(docId)
      .set({
        docId: docId,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        action: 'PRINT',
        name: this.state.name,
        company: this.state.company,
        busho: this.state.busho,
        email: this.state.email,
        people: Number(this.props.data.office_people),
        area: Number(this.props.data.office_area),
        rent: Number(this.props.data.office_rent),
        kako_free: Number(this.props.data.kako_free),
        now_free: Number(this.props.data.now_free),
        new_free: Number(this.props.data.new_free),
        kako_shusha: Number(this.props.data.kako_shusha),
        now_shusha: Number(this.props.data.now_shusha),
        new_shusha: Number(this.props.data.new_shusha),
        kako_remotefeeP: this.props.data.kako_remotefeeP,
        now_remotefeeP: this.props.data.now_remotefeeP,
        new_remotefeeP: this.props.data.new_remotefeeP,
        kako_teatejukyu: Number(this.props.data.kako_teatejukyu),
        now_teatejukyu: Number(this.props.data.now_teatejukyu),
        new_teatejukyu: Number(this.props.data.new_teatejukyu),
      });
  }

  render() {
    return (
      <div>
        <Box position="fixed" top={0} left={0} right={0} bottom={0} bgcolor="rgba(0,0,0,0.6)">
          <Box
            position="absolute"
            top={5}
            left={0}
            right={0}
            bottom={0}
            width={500}
            height={750}
            m="auto"
            bgcolor="#FFFF"
          >
            <Box position="absolute" top={15} right={15} width={30} height={30} {...closeIconProps}>
              <IconButton
                size="small"
                color="inherit"
                onClick={() => {
                  this.props.handleToCloseModal();
                  this.props.calc();
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <Box marginTop={4} marginLeft={5} marginRight={5}>
              <h1 className="modal_tittle">
                Work Place Simulator <span>体験版</span>
              </h1>
              <Box marginTop={1}>
                <h5 className="modal_discription">
                  ワークプレイス・シュミレーター 体験版
                  <br />
                  出社率とオフィススペースの割合に応じたシュミレーション
                </h5>
              </Box>
              <Box marginTop={1}>
                <h5 className="modal_discription">
                  下記連絡事項をご入力いただけるとシュミレーション結果を印刷可能です。
                  <br />
                  注意事項にご同意の上、PDFボタンを押してください。
                </h5>
              </Box>

              <Box marginTop={2}>
                <Grid container direction="column">
                  <Grid item>
                    <Box>
                      <TextFieldInfo
                        id="outlined-basic"
                        variant="outlined"
                        margin="none"
                        fullWidth={true}
                        label="お名前"
                        value={this.state.name}
                        inputProps={{
                          style: { fontSize: 12, textAlign: 'left', fontFamily: 'Noto Sans JP' },
                        }}
                        InputLabelProps={{
                          style: { fontSize: 12, color: '#9B88FF', fontFamily: 'Noto Sans JP' },
                        }}
                        onChange={(e) => {
                          this.handleNameChange(e.target.value);
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box marginTop={1.5}>
                      <TextFieldInfo
                        id="outlined-basic"
                        variant="outlined"
                        margin="none"
                        fullWidth={true}
                        label="会社名"
                        value={this.state.company}
                        inputProps={{
                          style: { fontSize: 12, textAlign: 'left', fontFamily: 'Noto Sans JP' },
                        }}
                        InputLabelProps={{
                          style: { fontSize: 12, color: '#9B88FF', fontFamily: 'Noto Sans JP' },
                        }}
                        onChange={(e) => {
                          this.handleCompanyChange(e.target.value);
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid>
                    <Box marginTop={1.5}>
                      <TextFieldInfo
                        id="outlined-basic"
                        variant="outlined"
                        margin="none"
                        fullWidth={true}
                        label="部署名"
                        value={this.state.busho}
                        inputProps={{
                          style: {
                            fontSize: 12,
                            textAlign: 'left',
                            fontFamily: 'Noto Sans JP',
                          },
                        }}
                        InputLabelProps={{
                          style: { fontSize: 12, color: '#9B88FF', fontFamily: 'Noto Sans JP' },
                        }}
                        onChange={(e) => {
                          this.handleBushoChange(e.target.value);
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid>
                    <Box marginTop={1.5}>
                      <TextFieldInfo
                        id="outlined-basic"
                        variant="outlined"
                        margin="none"
                        fullWidth={true}
                        label="メールアドレス"
                        value={this.state.email}
                        inputProps={{
                          style: {
                            fontSize: 12,
                            textAlign: 'left',
                            fontFamily: 'Noto Sans JP',
                          },
                        }}
                        InputLabelProps={{
                          style: { fontSize: 12, color: '#9B88FF', fontFamily: 'Noto Sans JP' },
                        }}
                        onChange={(e) => {
                          this.handleEmailChange(e.target.value);
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              <Box marginTop={3} textAlign="left">
                <p className="printmodal-discription1">提供資料の精度について</p>
                <p className="privacy_policy">
                  本サービスでご提供する資料は、あくまでワークプレイス刷新の検討フェーズの活用を目的としたものです。そのため、働き方のデータ整理・設計・予算などについては想定値も多く高い精度は保証できませんことをあらかじめご了承ください。あくまで企画書としてご利用いただ
                  ければ幸いです。
                </p>
              </Box>
              <Box marginTop={1} textAlign="left">
                <p className="printmodal-discription1">個人情報について</p>
                <p className="privacy_policy">
                  本サービスで取り扱う個人情報については、下記の保護方針に準じた取り扱いとさせていただきます。
                  <br />
                  <a href="https://workpath.co.jp/privacy.html">https://workpath.co.jp/privacy.html</a>
                </p>
              </Box>
              <Box marginTop={1} display="flex" justifyContent="center" alignItems="center">
                <h5 className="modal_agree">上記注意事項に同意します</h5>
                <Checkbox defaultChecked={false} checked={this.state.doui} onChange={(e) => this.handleDouiChange(e)} />
              </Box>

              <Box marginTop={2}>
                <ColorButtonPurple
                  size="large"
                  variant="outlined"
                  onClick={() => this.handelOnPDF()}
                  disabled={this.state.error || !this.state.doui}
                >
                  PDF
                </ColorButtonPurple>
              </Box>
            </Box>
          </Box>
        </Box>
      </div>
    );
  }
}

export default withRouter(PrintModal);
